<div style="background-color: #eaeff2">
    <p-table [value]="company" dataKey="name">
        <ng-template pTemplate="header">
            <tr>
                <th></th>
                <th>
                    Company Name
                    <!-- <p-sortIcon field="name"></p-sortIcon> -->
                </th>
                <th>Company Logo</th>
                <th>
                    Founders
                    <!-- <p-sortIcon field="founder"></p-sortIcon> -->
                </th>
                <th>
                    Established Date
                    <!-- <p-sortIcon field="estDate"></p-sortIcon> -->
                </th>
                <th>Social</th>
                <th>
                    Active/Inactive
                    <!-- <p-sortIcon field="active"></p-sortIcon> -->
                </th>
                <th>Actions</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-company let-expanded="expanded">
            <tr>
                <td>
                    <button type="button" pButton pRipple [pRowToggler]="company"
                        class="p-button-text p-button-rounded p-button-plain" [icon]="
                            expanded
                                ? 'pi pi-chevron-down'
                                : 'pi pi-chevron-right'
                        "></button>
                </td>
                <td>{{ company.name }}</td>
                <td>
                    <img [src]="company.image" [alt]="company.name" width="100" class="p-shadow-4" />
                </td>
                <td>{{ company.founder }}</td>
                <td>{{ company.estDate | date : "MM/dd/yyyy" }}</td>
                <td>
                    <a [href]="'http://' + company.web" target="_blank" [title]="company.web">
                        <button pButton pRipple type="button" class="p-button-text" icon="fa fa-globe fa-lg"></button>
                    </a>
                    <a [href]="'http://' + company.twitter" target="_blank" [title]="company.twitter">
                        <button pButton pRipple type="button" class="p-button-text" icon="fa fa-twitter fa-lg"></button>
                    </a>
                    <a [href]="'http://' + company.facebook" target="_blank" [title]="company.facebook">
                        <button pButton pRipple type="button" class="p-button-text"
                            icon="fa fa-facebook fa-lg"></button>
                    </a>
                </td>
                <td>
                    <span [class]="company.active ? 'ptagActive' : 'ptagInactive'">{{ company.active ? "Active" :
                        "Inactive" }}</span>
                </td>
                <td class="action">
                    <button pButton pRipple class="p-button-text" (click)="addBranch(company)" type="button"
                        icon="pi pi-plus"></button>
                    <button pButton pRipple class="p-button-text" (click)="editCompany(company)" type="button"
                        icon="pi pi-pencil"></button>
                </td>
            </tr>
        </ng-template>
        <ng-template pTemplate="rowexpansion" let-company>
            <tr>
                <td colspan="8">
                    <div class="p-p-3">
                        <p-tabView (onChange)="changeTabView($event)">
                            <p-tabPanel header="Locations">
                                <p-table #location [value]="company.branches" dataKey="id"
                                    [(selection)]="selectedBranches" [resizableColumns]="true" [scrollable]="true"
                                    styleClass="p-datatable-gridlines"
                                    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                                    [paginator]="true" [rows]="15" [showCurrentPageReport]="true"
                                    [rowsPerPageOptions]="tableShowMore"
                                    [globalFilterFields]="['locationId', 'name', 'address' ,'emailId' , 'locationType','country' ]">
                                    <ng-template pTemplate="caption">
                                        <div class="p-text-right">
                                        </div>
                                        <div class="table-header p-d-flex p-jc-between">
                                            <div>
                                                <span class="p-input-icon-left">
                                                    <i class="pi pi-search p-ml-1"></i>

                                                    <input type="text" class="p-ml-1" pInputText placeholder="Search..."
                                                        (input)="location.filterGlobal($event.target.value, 'contains')" />
                                                </span>
                                            </div>
                                            <div>
                                            </div>
                                            <div>
                                                <p-button *ngIf="!isEnable" styleClass="p-mr-3"
                                                    [disabled]="selectedFactor.length <= 0" label="Enable"
                                                    (click)="enableDisableFactor(true)"></p-button>
                                                <div>
                                                    <p-button label="Delete" [disabled]="selectedBranches.length <=0"
                                                        (click)="deleteAddress()"></p-button>
                                                </div>
                                            </div>
                                        </div>

                                    </ng-template>
                                    <ng-template pTemplate="header">
            <tr>
                <th style="border-right: 1px solid var(--primary-color);" pResizableColumn>
                    <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
                </th>
                <th style="border-right: 1px solid var(--primary-color);" pResizableColumn>
                    Location Id
                    <!-- <p-sortIcon field="locationId"></p-sortIcon> -->
                </th>
                <th style="border-right: 1px solid var(--primary-color);" pResizableColumn>
                    Location Name
                    <!-- <p-sortIcon field="name"></p-sortIcon> -->
                </th>
                <th style="border-right: 1px solid var(--primary-color);" pResizableColumn>
                    Location Type
                    <!-- <p-sortIcon field="type"></p-sortIcon> -->
                </th>
                <th style="border-right: 1px solid var(--primary-color);" pResizableColumn>
                    Phone
                    <!-- <p-sortIcon field="phone"></p-sortIcon> -->
                </th>
                <th style="border-right: 1px solid var(--primary-color);" pResizableColumn>
                    Address
                    <!-- <p-sortIcon field="address"></p-sortIcon> -->
                </th>
                <th style="border-right: 1px solid var(--primary-color);" pResizableColumn>
                    Email
                    <!-- <p-sortIcon field="emailId"></p-sortIcon> -->
                </th>
                <th pResizableColumn style="width: 8rem"></th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-branch let-i="rowIndex">
            <tr *ngIf="company.branches[i].headOffice && i == 0">
                <td colspan="6">
                    <h6 style="margin: 0 !important">
                        Head Office
                    </h6>
                </td>
            </tr>
            <tr
                *ngIf="(!company.branches[i].headOffice && i == 0) || (!company.branches[i].headOffice && i > 0 && company.branches[i-1].headOffice)">
                <td colspan="6">
                    <h6 style="margin: 0 !important">
                        Locations
                    </h6>
                </td>
            </tr>
            <tr>
                <td>
                    <p-tableCheckbox *ngIf="!company.branches[i].headOffice" [value]="branch"></p-tableCheckbox>
                </td>
                <td style="white-space: normal;">{{ branch.locationId }}</td>
                <td style="white-space: normal;">{{ branch.name }}</td>
                <td>{{ branch.locationType }}</td>
                <td>{{ branch.phone }}</td>
                <td style="white-space: normal;">
                    {{ branch.address }}
                    {{ branch.city }},
                    {{ branch.state }},
                    {{ branch.country }}
                    {{ branch.zip }}
                </td>
                <td>{{ branch.emailId }}</td>
                <td class="action">
                    <!-- <pre>{{branch |json}}</pre> -->
                    <!-- <button pButton pRipple class="p-button-text" type="button" icon="pi pi-eye"></button> -->
                    <button pButton pRipple class="p-button-text" (click)="editBranch(branch)" type="button"
                        icon="pi pi-pencil"></button>
                    <button pButton pRipple class="p-button-text p-button-danger" (click)="
                                                                                    deleteBranch(branch)
                                                                                " type="button"
                        icon="pi pi-trash"></button>
                </td>
            </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
            <tr>
                <td colspan="6">
                    There are no location for this
                    company yet.
                </td>
            </tr>
        </ng-template>
    </p-table>
    </p-tabPanel>
    <p-tabPanel header="Map">
        <div class="map-wrapper modern-marker-map">
            <div id="map" style="width: 100%; height: 500px;"></div>
        </div>
    </p-tabPanel>
    <p-tabPanel header="Currency">
        <p-table [value]="allCurrencies">
            <ng-template pTemplate="header">
                <tr>
                    <th>Name</th>
                    <th class="p-text-center">Symbol</th>
                    <th class="p-text-center">Base Currency</th>
                    <th>Exchange Rate</th>
                    <th>Exchange Updated Date</th>
                    <th>Exchange Updated By</th>
                    <th>Is Active</th>
                    <th>Action</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-currency let-i="rowIndex">
                <tr>
                    <td>{{ currency?.code }} - {{ currency?.country?.name }}</td>
                    <td class="p-text-center">
                        {{ currency?.symbol }}
                    </td>
                    <td class="p-text-center action">
                        <span *ngIf="currency.isBaseCurrency">
                            <button pButton pRipple type="button" class="p-button-text" icon="pi pi-check"></button>
                        </span>
                    </td>
                    <td *ngIf="currency.isBaseCurrency">
                        {{ currency?.exchangeRate }}
                    </td>
                    <td pEditableColumn *ngIf="!currency.isBaseCurrency">
                        <p-cellEditor>
                            <ng-template pTemplate="input">
                                <p-inputNumber [formControl]="currencyFormArray?.at(i).get('exchangeRate')" mode="decimal" [minFractionDigits]="0" [maxFractionDigits]="10" (onBlur)="updateBaseCurrency(currency, i)"></p-inputNumber>
                                <div *ngIf="currencyFormArray?.at(i).get('exchangeRate')?.invalid && currencyFormArray?.at(i).get('exchangeRate')?.touched" class="p-error">Exchange Rate must be greater than 0.</div>
                            </ng-template>
                            <ng-template pTemplate="output">
                                {{ currencyFormArray?.at(i)?.get("exchangeRate")?.value }}
                            </ng-template>
                        </p-cellEditor>
                    </td>
                    <td>
                        {{ currency?.exchangeRateUpdatedDate | localDate: "dateTime" : false }}
                    </td>
                    <td>
                        {{ currency?.rateUpdateByUser }}
                    </td>
                    <td>
                        {{ currency?.statusId == "1" ? "Yes" : "No" }}
                    </td>
                    <td class="action">
                        <ng-container *ngIf="currency.isBaseCurrency">
                            <button pButton pRipple class="p-button-text" type="button" icon="pi pi-plus" (click)="showAddCurrency()"></button>
                        </ng-container>
                        <ng-container *ngIf="!currency.isBaseCurrency">
                            <button pButton pRipple class="p-button-text" type="button" icon="pi pi-pencil" (click)="showEditCurrency(currency)"></button>
                            <button pButton pRipple class="p-button-text p-button-danger" type="button" icon="pi pi-trash" (click)="checkDeleteStatus(currency)"></button>
                        </ng-container>
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </p-tabPanel>  
    <p-tabPanel header="Settings">
        <p-table [value]="allSettings">
            <ng-template pTemplate="header">
                <tr>
                    <th>Name</th>
                    <th>Value</th>
                    <th>Action</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-product>
                <tr>
                    <td>{{ product.name }} <span *ngIf="product.code=='qtydecimal'">(e.g {{2.2 | customNumberFormat: product.value}})</span></td>
                    <td>{{ product.value }}</td>
                    <td class="action">
                        <button pButton pRipple class="p-button-text" type="button" icon="pi pi-pencil" (click)="
                                                                                editSetting(product,true)
                                                                            "></button>
                    </td>
                </tr>
            </ng-template>
        </p-table>
        <div *ngIf="allSettings.length == 0" class="centered-spinner" style="margin: auto;">
            <p-progressSpinner [style]="{width: '40px', height: '40px'}" strokeWidth="4"></p-progressSpinner>
        </div>
    </p-tabPanel>
    <p-tabPanel header="Access Control">
        <div class="card">
            <ng-container *ngFor="let control of accessControlData; let accessIndex=index">
                <div *ngIf="!(!roleMenuPermission && control.id==2)" class="p-field-radiobutton">
                    <p-radioButton name="control" [value]="control" [(ngModel)]="selectedAccessControl"
                        inputId="control1">
                    </p-radioButton>
                    <label for="control1">{{control.name}}</label>
                </div>
                <div *ngIf="control.id==2 && selectedAccessControl?.id==2" class="p-ml-4">
                    <div class="p-d-flex p-ai-center">
                        <p-checkbox [(ngModel)]="control.isReportHierarchyBased" [binary]="true" inputId="access-control-2-{{accessIndex}}" label="All Users, All Access for Reports"/>
                    </div>
                </div>
            </ng-container>
            <div class="p-text-right">
                <button type="button" pButton label="Cancel" class="p-button-secondary p-mr-2"></button>
                <button type="button" pButton label="Save" (click)="saveAccessControl()"></button>
            </div>
        </div>
    </p-tabPanel>
    <p-tabPanel header="Multi Factor Authentication">
        <p-table #dt2 [value]="twoFactor" [(selection)]="selectedFactor" dataKey="id" responsiveLayout="scroll"
            styleClass="p-datatable-gridlines" class="no-caption-padding"
            [globalFilterFields]="['product.name','product.email','product.mfaMethod','name', 'email', 'mfaMethod']"
            [rows]="15" [showCurrentPageReport]="true" [rowsPerPageOptions]="[15,30,50,100]" [paginator]="true"
            currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries">
            <ng-template pTemplate="caption">
                <div class="p-text-right">
                </div>
                <div class="table-header p-d-flex p-jc-between">
                    <div>
                        <p-toggleButton class="p-mb-2 p-mr-2" [onLabel]="'Enabled Users'" offLabel="Disabled Users"
                            [onIcon]="'pi pi-check'" [offIcon]="'pi pi-times'" iconPos="right" [(ngModel)]="isEnable"
                            (onChange)="filterTableRowsMFA()">
                        </p-toggleButton>
                        <span class="p-input-icon-left">
                            <i class="pi pi-search"></i>
                            <input #searchInput pInputText type="text"
                                (input)="dt2.filterGlobal($event.target.value, 'contains')" placeholder="Search user" />
                        </span>
                    </div>
                    <div>
                        <span class="btnBars p-mr-2" pTooltip="Refresh List" tooltipPosition="top"
                            (click)="refreshData()">
                            <i class="pi pi-refresh p-mr-2 p-cursor-pointer"></i>
                        </span>
                        <p-button *ngIf="!isEnable" styleClass="p-mr-3" [disabled]="selectedFactor.length <= 0"
                            label="Enable" (click)="enableDisableFactor(true)"></p-button>
                        <p-button *ngIf="isEnable" label="Disable" [disabled]="selectedFactor.length <=0"
                            (click)="enableDisableFactor(false)"></p-button>
                    </div>
                </div>
            </ng-template>
            <ng-template pTemplate="header">
                <tr>
                    <th style="width: 2rem">
                        <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
                    </th>
                    <th>Name</th>
                    <th>Email</th>
                    <th>MFA-Setup Status</th>
                    <th>MFA-Setup Type</th>
                    <th>MFA Enabled</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-product>
                <tr>
                    <td>
                        <p-tableCheckbox [value]="product"></p-tableCheckbox>
                    </td>
                    <td>{{product.name}}</td>
                    <td>{{product.email}}</td>
                    <td>
                        <!-- Wrap the content in an anchor tag and attach a click event -->
                        <a *ngIf="product.mfaSetupStatus" href="javascript:void(0)"
                            (click)="openConfirmationDialog(product)" class="p-link underline-link"
                            pTooltip="Re-set Authentication">
                            {{product.mfaSetupStatus}}
                        </a>
                        <span *ngIf="!product.mfaSetupStatus">{{product.mfaSetupStatus}}</span>
                    </td>
                    <td> {{product.mfaMethod}}</td>
                    <td>
                        <i class="pi"
                            [ngClass]="{ 'pi-check-circle': product.mfaEnableStatus, 'pi-times-circle': !product.mfaEnableStatus }"
                            [ngStyle]="{ 'color': product.mfaEnableStatus ? '#32CD32' : 'red' }"></i>
                    </td>

                </tr>
            </ng-template>
        </p-table>
    </p-tabPanel>
    </p-tabView>
</div>
</td>
</tr>
</ng-template>
</p-table>
<div *ngIf="company.length == 0" class="centered-spinner" style="margin: auto;">
    <p-progressSpinner [style]="{width: '40px', height: '40px'}" strokeWidth="4"></p-progressSpinner>
</div>
</div>

<p-dialog header="Edit Company Detail" [(visible)]="displayCompany" [style]="{ width: '50vw' }" [modal]="true"
    [responsive]="true" [baseZIndex]="10000">
    <div class="p-grid">
        <div class="p-col-6">
            <label>Company Name
                <span style="color: red; font-size: 16px">*</span></label>
            <input type="text" pInputText required #fcompany="ngModel" [(ngModel)]="tempCompany.name" />
        </div>
        <div class="p-col-6">
            <label>Founder Name
                <span style="color: red; font-size: 16px">*</span></label>
            <input type="text" pInputText required #ffounder="ngModel" [(ngModel)]="tempCompany.founder" />
        </div>
        <div class="p-col-6">
            <label>Established Date
                <span style="color: red; font-size: 16px">*</span></label>
            <!-- [monthNavigator]="true" [yearNavigator]="true" -->
            <p-calendar appendTo="body" [(ngModel)]="tempCompany.estDate" [maxDate]="today" [monthNavigator]="true"
                [yearNavigator]="true" yearRange="2000:2040" [showIcon]="true" inputId="icon"></p-calendar>
            <!-- <input type="text" pInputText required #fName="ngModel" [(ngModel)]="tempCompany.estDate"> -->
        </div>
        <div class="p-col-6">
            <label>Website URL </label>
            <input type="text" pInputText required #fweb="ngModel" [(ngModel)]="tempCompany.web" />
        </div>
        <div class="p-col-6">
            <label>Twitter ID </label>
            <input type="text" pInputText required #ftwitter="ngModel" [(ngModel)]="tempCompany.twitter" />
        </div>
        <div class="p-col-6">
            <label>Facebook ID </label>
            <input type="text" pInputText required #ffacebook="ngModel" [(ngModel)]="tempCompany.facebook" />
        </div>
        <div class="p-col-6">
            <label>Company Logo </label>
            <div style="width: fit-content; text-align: center">
                <img (click)="fileInput.click()" [src]="tempCompany.image" [alt]="tempCompany.name" width="150"
                    class="p-shadow-4" />
                <div style="margin: 10px auto">
                    <button pButton label="Browse Logo" (click)="fileInput.click()"></button>
                </div>
            </div>
            <input hidden (change)="selectFile($event)" #fileInput type="file" id="file" />
        </div>
        <div class="p-col-6">
            <label>Time Zone </label>
            <p-dropdown [options]="timeZoneList" [(ngModel)]="selectedTimeZone" placeholder="Select timezone "
                appendTo="body" optionLabel="name" name="timeZone" [ngModelOptions]="{ standalone: true }">
            </p-dropdown>
        </div>
    </div>

    <ng-template pTemplate="footer">
        <button pButton pRipple (click)="updateOrganization()" label="Save"></button>
        <button pButton pRipple (click)="displayCompany = false" label="Cancel" class="p-button-secondary"></button>
    </ng-template>
</p-dialog>

  <p-dialog [header]="displayMode === 'ADD' ? 'Add Currency' : 'Edit Currency'" [(visible)]="displayCurrencyAdd" [style]="{ width: '50vw' }" [modal]="true" [responsive]="true">
    <form [formGroup]="currencyForm">
        <div class="p-grid">
            <div class="p-col-6">
                <label for="countryCode">Country Code<span style="color: red; font-size: 16px">*</span></label>
                <p-dropdown [options]="availableCurrencyList" placeholder="Select Country Code" appendTo="body" formControlName="selectedCurrency" optionLabel="label" dataKey="currencyId"  [filter]="true" (onChange)="onCurrencySelect()"> </p-dropdown>
                <div *ngIf="currencyForm.get('selectedCurrency')?.hasError('duplicate')" class="p-error">
                    This currency is already selected. Please choose another.
                  </div>
                <div *ngIf="currencyForm.get('selectedCurrency')?.hasError('empty')" class="p-error">
                    Please select a country code.
                  </div>
                <div *ngIf="currencyForm.get('selectedCurrency')?.hasError('required') && currencyForm.get('selectedCurrency')?.touched" class="p-error">Please select a country code.</div>
            </div>

            <div class="p-col-6">
                <label for="exchangeRate">Exchange Rate ({{ currencyForm.get("selectedCurrency")?.value?.code }})<span style="color: red; font-size: 16px">*</span></label>
                <input type="text" pInputText class="w-100" formControlName="exchangeRate" appDecimalNumber/>
                <div *ngIf="currencyForm.get('exchangeRate')?.hasError('min') && currencyForm.get('exchangeRate')?.touched" class="p-error">Exchange Rate must be greater than 0.</div>
                <div *ngIf="currencyForm.get('exchangeRate')?.hasError('required') && currencyForm.get('exchangeRate')?.touched" class="p-error">Exchange rate is required.</div>
            </div>
        </div>

        <div class="p-p-3">
            <div class="p-d-flex p-mt-2">
                <p-checkbox formControlName="defaultRateEnabled" binary="true" inputId="set" class="p-mr-2"> </p-checkbox>
                <label for="set" class="p-mt-1">
                    Set this rate as default for
                    {{ exchangeRatedate | localDate: "date" }}
                </label>
            </div>
            <div class="p-d-flex p-my-2">
                <p-checkbox formControlName="enableRecalculateItemRate" binary="true" inputId="recalculate" class="p-mr-2"> </p-checkbox>
                <label for="recalculate" class="p-mt-1">Re-calculate item prices based on this rate</label>
            </div>
        </div>
    </form>

    <ng-template pTemplate="footer">
        <div class="p-d-flex p-jc-end p-gap-2">
            <button pButton pRipple type="button" (click)="displayCurrencyAdd = false" label="Cancel" class="p-button-secondary"></button>
            <button pButton pRipple type="button" label="Save" (click)="saveCurrency(displayMode)" class="p-button-primary" [disabled]="currencyForm.invalid"></button>
        </div>
    </ng-template>
</p-dialog>


<p-dialog [header]="branchHeader" [(visible)]="displayBranch" [style]="{ width: '50vw' }"
    (onHide)="hideAddEditBranchModal()">
    <form #branchForm="ngForm" (ngSubmit)="saveAddEditBranch()">
        <div class="card" *ngIf="displayBranch">
            <div class="p-grid">
                <div class="p-col-6">
                    <label>Location Id
                        <span style="color: red; font-size: 16px">*</span>
                    </label>
                    <input type="text" name="locationId" pInputText required #location="ngModel"
                        [(ngModel)]="tempBranch.locationId" />
                    <small *ngIf="location.invalid && (location.dirty || location.touched)" class="p-invalid p-mt-2">
                        <div class="p-invalid p-mt-2" *ngIf="location.errors.required">Location Id is required.</div>
                    </small>
                </div>
                <div class="p-col-6">
                    <label>Branch Name
                        <span style="color: red; font-size: 16px">*</span></label>
                    <input type="text" name="name" pInputText required #bName="ngModel" [(ngModel)]="tempBranch.name" />
                    <small *ngIf="bName.invalid && (bName.dirty || bName.touched)" class="p-invalid p-mt-2">
                        <div class="p-invalid p-mt-2" *ngIf="bName.errors.required">Branch name is required.</div>
                    </small>
                </div>
                <div class="p-col-6">
                    <label>is Head Office </label>
                    <p-checkbox name="headOffice" [(ngModel)]="tempBranch.headOffice" binary="true"
                        inputId="binary"></p-checkbox>
                </div>
                <div class="p-col-6">
                    <label for="phoneNumber">Phone Number </label>
                    <input type="text" name="phone" pInputText required #number="ngModel"
                        [(ngModel)]="tempBranch.phone" />
                </div>
                <!-- <div class="p-field p-grid p-col-6">
                    <div class="p-col-12 p-md-5">
                        <label for="country">Select Country</label>
                        <p-dropdown [options]="countryData" [filter]="true" filterBy="CountryName"
                            optionLabel="CountryName" [autoDisplayFirst]="false" [ngModelOptions]="{standalone:true}"
                            [(ngModel)]="selectedCountry" placeholder="Select Country"
                            (onChange)="onCountrySelect($event, phone)" class="inline" appendTo="body">
                        </p-dropdown>
                    </div>
                    <div class="p-col-12 p-md-7">
                        <label for="phoneNumber">Phone Number</label>
                        <div class="p-inputgroup">
                            <span class="p-inputgroup-addon">+{{selectedCountry?.PhoneCode}}</span>
                            <p-inputMask type="text" *ngIf="phoneNumberFormat && !maskingDisabled"name="phone" [mask]="phoneNumberFormat" required #number="ngModel"
                                [(ngModel)]="tempBranch.phone" [autoClear]="false"  slotChar="_"></p-inputMask>
                            <input type="text" *ngIf="!(phoneNumberFormat && !maskingDisabled)" name="phone" pInputText required #number="ngModel" [(ngModel)]="tempBranch.phone" />
                        </div>
                    </div>

                </div> -->
            </div>
        </div>
        <div class="header">
            <h5>Address Details</h5>
        </div>
        <div class="card">
            <div class="p-field p-grid">
                <div class="p-col-12 p-md-6">
                    <label>Street Address 1
                        <span style="color: red;">*</span></label>
                    <!-- <input type="text" pInputText required #fName="ngModel" [(ngModel)]="tempBranch.address"> -->
                    <lion-gm-place-autocomplete [formattedAddress]="addressInput"
                        (onRemoveAddress)="onRemoveAddressLocation($event)" (onAddressChange)="onAddressChanged($event)"
                        (onSettingAddrress)="onAddressBlur($event)">
                    </lion-gm-place-autocomplete>
                    <small *ngIf="showAddressValidationError" class="p-invalid p-mt-2">
                        <div class="p-invalid p-mt-2" *ngIf="showAddressValidationError"> Address is required.
                        </div>
                    </small>
                </div>
                <div class="p-col-12 p-md-6">
                    <label>Street Address 2</label>
                    <input pInputText type="text" [(ngModel)]="tempBranch.streetAddress2" />
                </div>
            </div>
            <div class="p-field p-grid">
                <div class="p-col-12 p-md-6">
                    <label>Country </label>
                    <p-dropdown name="country" [options]="countries" [filter]="true" filterBy="name" appendTo="body"
                        (onChange)="loadCountryStates()" [(ngModel)]="selectedAddressCountry"
                        placeholder="Select Country" optionLabel="name">
                    </p-dropdown>
                </div>
                <div class="p-col-12 p-md-6">
                    <label>State </label>
                    <p-dropdown name="State" [options]="allStates" [filter]="true" filterBy="name" appendTo="body"
                        [(ngModel)]="selectedAddressState" (onChange)="loadCountryCities()" placeholder="Select State"
                        optionLabel="name">
                    </p-dropdown>
                </div>
            </div>
            <div class="p-field p-grid">
                <div class="p-col-12 p-md-6">
                    <label>City </label>
                    <p-dropdown name="City" [options]="allCities" [filter]="true" filterBy="name" appendTo="body"
                        [(ngModel)]="selectedAddressCity" placeholder="Select City" optionLabel="name">
                    </p-dropdown>
                </div>
                <div class="p-col-12 p-md-6">
                    <label>Zip Code </label>
                    <input name="Zip" type="text" name="zip" pInputText required #zCode="ngModel"
                        [(ngModel)]="tempBranch.zip" />
                </div>
            </div>
            <div class="p-field p-grid">
                <div class="p-col-12 p-md-6">
                    <label>Location Type<span style="color: red">*</span></label>
                    <p-dropdown name="Location type" [options]="locationTypes" #locationType="ngModel"
                        name="locationTypeObj" [filter]="true" appendTo="body" required
                        [(ngModel)]="tempBranch.locationTypeObj" placeholder="Select Location Type" optionLabel="name">
                    </p-dropdown>
                    <small *ngIf="locationType.invalid && (locationType.dirty || locationType.touched)"
                        class="p-invalid p-mt-2">
                        <div class="p-invalid p-mt-2" *ngIf="locationType.errors.required"> Please Select
                            Location Type </div>
                    </small>
                </div>
                <div class="p-col-12 p-md-6">
                    <label>Email </label>
                    <input name="Email" type="text" name="emailId" pInputText required #email="ngModel"
                        [(ngModel)]="tempBranch.emailId" />
                </div>
            </div>
        </div>


        <div class="header" *ngIf="showAccountInfoMore">
            <h5>Business Details</h5>
        </div>
        <div class="card" *ngIf="showAccountInfoMore">
            <div class="p-field p-grid">
                <div class="p-col-12 p-md-6">
                    <label>Doing Business as (DBA)</label>
                    <input pInputText type="text" />
                </div>
                <div class="p-col-12 p-md-6">
                    <label>Tax ID (EIN)</label>
                    <input pInputText type="text" />
                </div>
            </div>
            <div class="p-field p-grid">
                <div class="p-col-12 p-md-6">
                    <label>Number of Employees</label>
                    <p-dropdown [options]="employees" name="employeesRange" placeholder="Select Employee"
                        inputId="employeesRange" optionLabel="name" dataKey="id"></p-dropdown>
                </div>
                <div class="p-col-12 p-md-6">
                    <label>Estimated Annual Revenue</label>
                    <p-dropdown [options]="revenues" placeholder="Select Revenue" name="annualRevenue"
                        inputId="annualRevenue" optionLabel="name" dataKey="id"></p-dropdown>
                </div>
            </div>
            <div class="p-field p-grid">
                <div class="p-col-12 p-md-6">
                    <label>Ownership Type</label>
                    <p-dropdown [options]="ownerships" name="ownerShipType" placeholder="Select ownership"
                        inputId="ownership" optionLabel="name" dataKey="id" (onChange)="onChangeOwnership($event)"
                        [filter]="true" filterBy="name"></p-dropdown>
                </div>
                <div class="p-col-12 p-md-6">
                    <label>Business Classification</label>
                    <p-dropdown [options]="categories" name="businessClassification"
                        placeholder="Select business classification" inputId="businessClassification" optionLabel="name"
                        dataKey="id" [filter]="true" [filterBy]="'name'"></p-dropdown>
                </div>
            </div>
            <div class="p-field p-grid">
                <div class="p-col-12 p-md-6">
                    <label>Industry</label>
                    <p-dropdown [options]="industries" placeholder="Select Industry" optionLabel="name" name="industry"
                        dataKey="id" inputId="industry" [filter]="true" [filterBy]="'name'"></p-dropdown>
                </div>
            </div>
        </div>
        <div class="p-field p-formgrid p-grid account-info-show-more">
            <div class="p-col-12">
                <button type="button" style="float: right" pButton (click)="showAccountInfoMore = !showAccountInfoMore"
                    label="{{ showAccountInfoMore ? 'Show Less' : 'Show More' }}" class="p-button-secondary"></button>
            </div>
        </div>
    </form>
    <ng-template pTemplate="footer">
        <button pButton pRipple (click)="displayBranch = false" label="Cancel" class="p-button-secondary"></button>
        <button [disabled]="!(tempBranch.name && tempBranch.locationId && tempBranch.locationTypeObj)" pButton pRipple
            (click)="branchForm.ngSubmit.emit()" label="Save"></button>
    </ng-template>
</p-dialog>

<p-dialog header="{{companyForm.controls['code'].value | titlecase }}" [(visible)]="displaySetting2"
    [style]="{ width: '50vw' }" [modal]="true" [responsive]="true">
    <div *ngIf="companyForm" [formGroup]="companyForm">
        <div class="p-grid" *ngIf="companyForm.controls['code'].value =='timeout'">
            <div class="p-col-6">
                <label>Name</label>
                <input type="text" pInputText formControlName="name" />
                <div *ngIf="companyForm.get('name').invalid && companyForm.get('name').dirty">
                    <small class="p-error" *ngIf="companyForm.get('name').errors.required">
                        Name is required.
                    </small>
                </div>
            </div>
            <div class="p-col-6">
                <label>Idle Time: (HH:MM)</label>
                <p-calendar formControlName="value" [timeOnly]="true" inputId="timeonly" appendTo="body">
                </p-calendar>
                <div *ngIf="companyForm.get('value').invalid && companyForm.get('value').dirty">
                    <small class="p-error" *ngIf="companyForm.get('value').errors.required">
                        Idle Time is required.
                    </small>
                </div>
            </div>
        </div>
        <div class="p-grid"
            *ngIf="(companyForm.controls['code'].value =='decimal' || companyForm.controls['code'].value =='qtydecimal')">
            <div class="p-col-6">
                <label>Decimal Limit</label>
                <input type="text" pInputText onlyNumber formControlName="value" />
                <div *ngIf="companyForm.get('value').invalid && companyForm.get('value').dirty">
                    <small class="p-error" *ngIf="companyForm.get('value').errors.required">
                        Decimal Limit is required.
                    </small>
                    <small class="p-error" *ngIf="companyForm.get('value').errors.max">
                        Maximum Decimal Limit is 6.
                    </small>
                    <small class="p-error" *ngIf="companyForm.get('value').errors.min">
                        Minimum Decimal Limit is 0.
                    </small>
                </div>
            </div>
        </div>
    </div>

    <ng-template pTemplate="footer">
        <button pButton pRipple (click)="displaySetting2 = false" label="Cancel" class="p-button-secondary"></button>
        <button pButton pRipple label="Save" [disabled]="companyForm.invalid"
            (click)="saveDecimalValue(companyForm.value)"></button>
    </ng-template>
</p-dialog>
